import { useEffect, useRef, useState } from 'react';

/**
 * Tracks the same scroll-direction signal used by AppHeader so other
 * sticky elements (like the listings toolbar) can shift in coordination.
 *
 * Returns `true` when the AppHeader is visible (at top of page or scrolling up),
 * `false` when it is hidden (scrolling down past threshold).
 */
export function useHeaderVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollThreshold = 10;

      if (currentScrollY < scrollThreshold) {
        setIsVisible(true);
        lastScrollY.current = currentScrollY;
        return;
      }

      if (currentScrollY > lastScrollY.current + scrollThreshold) {
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY.current - scrollThreshold) {
        setIsVisible(true);
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return isVisible;
}